import React from 'react';

import { ToggleGroup, ToggleGroupItem } from '@/components/ui/toggle-group';
import { useUpsertIncidentStatusSummary } from 'components/IAP/hooks/incidentStatusSummaryHooks';
import { STATUS_SUMMARY_REPORT_VERSIONS } from 'components/IAP/ICSConstants';

type ReportVersionToggleProps = {
  statusSummaryId?: string;
  originalReportVersion?: string;
  readOnly?: boolean;
};

const ReportVersionToggle: React.FC<ReportVersionToggleProps> = ({
  statusSummaryId,
  originalReportVersion,
  readOnly = false,
}) => {
  const [reportVersion, setReportVersion] = React.useState<string>(
    originalReportVersion || 'Initial'
  );

  const upsertIncidentStatusSummary =
    useUpsertIncidentStatusSummary(statusSummaryId);

  const handleChange = (value: string) => {
    setReportVersion(value);
    upsertIncidentStatusSummary({ reportVersion: value });
  };

  return (
    <ToggleGroup
      // The group is the box's only control and the numbered title already
      // names it, so the accessible name comes from aria-label.
      aria-label="Report Version"
      data-testid="ics209-report-version"
      value={[reportVersion]}
      onValueChange={(next: unknown[]) => {
        const value = next[0];
        // Base UI clears the value when the pressed item is toggled off. The
        // form has no unset report version, so the current one stands.
        if (typeof value === 'string') handleChange(value);
      }}
      variant="outline"
      size="sm"
      spacing={0}
      disabled={readOnly}
    >
      {STATUS_SUMMARY_REPORT_VERSIONS.map((option) => (
        <ToggleGroupItem key={option.value} value={option.value}>
          {option.label}
        </ToggleGroupItem>
      ))}
    </ToggleGroup>
  );
};

export default ReportVersionToggle;
